import React from 'react';
import { FormGroupBaseStyled } from './style';
import withTheme, { lightTheme } from 'helpers/theme';

const FormGroupBase = React.forwardRef(({ ...props }, ref) => {
  return <FormGroupBaseStyled ref={ref} {...props} />;
});

export default withTheme(lightTheme)(FormGroupBase);
